import { Chip, CircularProgress, List, ListItem } from "@mui/material";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

import DataContext from "../../../../../../../context/DataContext";
import axios from "../../../../../../api/axios";

export const OrganizationAndPermissions = (props) => {
  const { userInfo, trigger } = props;
  const { userRoles } = useContext(DataContext);

  const [managedBy, setManagedBy] = useState();
  const [managingUsers, setManagingUsers] = useState();
  const [fetchManagedByLoading, setFetchManagedByLoading] = useState(true);
  const [fetchManagingUserLoading, setFetchManagingUserLoading] = useState(true);

  useEffect(() => {
    if (!userInfo?.pk) {
      return;
    }
    setFetchManagedByLoading(true);

    axios
      .get(`/api/user_manager/?user=${userInfo.pk}`, {
      })
      .then((response) => {
        const data = response.data.results;
        if (data?.[0]?.managed_by?.is_active) {
          setManagedBy(data[0]);
        }
        setFetchManagedByLoading(false);
      })
      .catch(() => {
        setFetchManagedByLoading(false);
      });
  }, [setManagedBy, trigger, userInfo, userRoles?.permissions]);

  useEffect(() => {
    if (!userInfo?.pk) {
      return;
    }
    setFetchManagingUserLoading(true);

    axios
      .get(`/api/user_manager/?managed_by=${userInfo.pk}`, {
      })
      .then((response) => {
        const data = response.data.results?.filter((managedBy) => !!managedBy?.user?.is_active);
        setManagingUsers(data);
        setFetchManagingUserLoading(false);
      })
      .catch(() => {
        setFetchManagingUserLoading(false);
      });
  }, [setManagingUsers, trigger, userInfo, userRoles?.permissions]);

  return (
    <div className="border-gray relative border-t py-2">
      <div className="flex items-center justify-between pb-2">
        <h3 className="text-lg font-bold">Organization & Permissions</h3>
      </div>
      <List className="p-0">
        <ListItem className="gap-2 pr-0">
          <span className="flex-[0_0_92px] whitespace-nowrap underline">Managed By:</span>
          {fetchManagedByLoading ? (
            <CircularProgress size="1.5rem" />
          ) : (
            <div className="flex-[1_1_auto] overflow-hidden" data-testid="fetch-managed-by-chip">
              {!!managedBy && (
                <Chip
                  label={managedBy.managed_by?.name}
                  color="primary"
                  size="small"
                  className="px-2"
                />
              )}
            </div>
          )}
        </ListItem>
        <ListItem className="gap-2 py-0 pr-0">
          <span className="flex-[0_0_124px] whitespace-nowrap underline">Managing Users:</span>
          {fetchManagingUserLoading ? (
            <CircularProgress size="1.5rem" />
          ) : (
            <div
              className="flex flex-[1_1_auto] gap-2 overflow-x-auto py-2"
              data-testid="fetch-managing-users-chips"
            >
              {!!managingUsers?.length &&
                managingUsers.map(
                  (user) =>
                    !!user && (
                      <Chip
                        key={user.pk}
                        label={user.user?.name}
                        color="primary"
                        size="small"
                        className="max-w-fit px-2"
                      />
                    )
                )}
            </div>
          )}
        </ListItem>
      </List>
    </div>
  );
};

OrganizationAndPermissions.propTypes = {
  userInfo: PropTypes.object,
  trigger: PropTypes.bool,
};
